import { QuickFilters } from './QuickFilters.js';
import { RangePicker } from './RangePicker/RangePicker.js';
import { SinglePicker } from './SinglePicker/SinglePicker.js';

const DatePicker = { RangePicker, QuickFilters, SinglePicker };

export { DatePicker };
//# sourceMappingURL=index.js.map
